module.exports = __webpack_public_path__ + "static/media/ceiling-down.ed1709b3.jpg";